import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { captureSupabaseError } from '../lib/sentry';

interface UploadResult {
  storagePath: string;
}

export function useUploadCertification() {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sanitizeFileName = (name: string) =>
    name.replace(/[^a-zA-Z0-9._-]/g, '_');

  async function uploadCertification(
    file: File,
    supplierId: string
  ): Promise<UploadResult | null> {
    setUploading(true);
    setError(null);

    try {
      const safeFileName = sanitizeFileName(file.name);
      const storagePath = `supplier-${supplierId}/certifications/${Date.now()}_${safeFileName}`;

      const { error: uploadError } = await supabase.storage
        .from('supplier-profile-assets')
        .upload(storagePath, file, {
          cacheControl: '3600',
          upsert: false,
        });

      if (uploadError) throw uploadError;

      return { storagePath };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      captureSupabaseError(err, { op: 'certifications.upload' });
      console.error('Certification upload failed:', err);
      setError(err.message ?? 'Upload failed');
      return null;
    } finally {
      setUploading(false);
    }
  }

  return { uploadCertification, uploading, error };
}
